"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledOptionsContainer = exports.StyledStrokeCardGrid = exports.StyledStrokeSelectedCard = exports.StyledColorContainer = exports.StyledSectionStrokeContainer = void 0;
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const { rem, toRemString } = ui_common_components_1.utils;
exports.StyledSectionStrokeContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  cursor: pointer;

  ${({ theme }) => (0, styled_components_1.css) `
    padding: ${rem(theme.Spacing.Size.Small)} ${rem(theme.Spacing.Size.XSmall)};
    gap: ${rem(theme.Spacing.Size.Small)};
  `}
`;
exports.StyledColorContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
exports.StyledStrokeSelectedCard = styled_components_1.default.div `
  height: 100%;
  width: 100%;
  z-index: 2;

  ${({ active, theme }) => (0, styled_components_1.css) `
    & > article {
      box-shadow: ${active
    ? `${toRemString([0, 0, 0, 1])} ${theme.Color.System.Primary}`
    : `${toRemString([0, 0, 0, 1])} ${theme.Color.Neutrals.Border}`};

      :hover {
        box-shadow: ${toRemString([0, 0, 0, 1])} ${theme.Color.System.Primary};
      }
    }
  `}
`;
exports.StyledStrokeCardGrid = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
  grid-template-rows: repeat(3, 1fr);
`;
exports.StyledOptionsContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XXSmall)};
`;
//# sourceMappingURL=Stroke.styles.js.map